import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { DIFFICULTY_CONFIG, DIFFICULTY_LEVELS } from '../interactiveEducationConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const QuizMeDifficultySelector = ({
  onDifficultyChange,
  selectedDifficulty
}) => /*#__PURE__*/_jsxs(Flex, {
  flexDirection: "column",
  children: [/*#__PURE__*/_jsx(Text, {
    as: "h2",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.interactiveEducation.quiz.quizMe"
    })
  }), /*#__PURE__*/_jsx(Text, {
    as: "h3",
    marginBlock: "800",
    marginInlineEnd: "700",
    children: /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.interactiveEducation.quiz.difficulty.selectLevel"
      })
    })
  }), DIFFICULTY_LEVELS.map(level => /*#__PURE__*/_jsx(SelectableButton, {
    block: true,
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: DIFFICULTY_CONFIG[level].description
    }),
    marginBlockEnd: "400",
    onClick: () => onDifficultyChange(level),
    selected: selectedDifficulty === level,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: DIFFICULTY_CONFIG[level].title
    }),
    type: "radio"
  }, level))]
});